var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsoltoLogoGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13",
    "data-name": "Group 13",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.324,
    height: 20.117,
    viewBox: "0 0 42.324 20.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comment",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chat",
    d: "M13.83,10.058a1.188,1.188,0,0,1-1.257,1.257H7.544a1.26,1.26,0,0,1-1.257-1.257A1.188,1.188,0,0,1,7.544,8.8h5.029A1.26,1.26,0,0,1,13.83,10.058Zm6.287-3.772A6.225,6.225,0,0,0,13.83,0H6.287A6.225,6.225,0,0,0,0,6.287V18.86a1.188,1.188,0,0,0,1.257,1.257H13.83a6.225,6.225,0,0,0,6.287-6.287Z",
    fill: "#bdc3c7",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Comment-2",
    "data-name": "Comment",
    transform: "translate(22.207 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chat-2",
    "data-name": "Chat",
    d: "M6.287,10.058a1.188,1.188,0,0,0,1.257,1.257h5.029a1.26,1.26,0,0,0,1.257-1.257A1.188,1.188,0,0,0,12.573,8.8H7.544A1.26,1.26,0,0,0,6.287,10.058ZM0,6.287A6.225,6.225,0,0,1,6.287,0H13.83a6.225,6.225,0,0,1,6.287,6.287V18.86a1.188,1.188,0,0,1-1.257,1.257H6.287A6.225,6.225,0,0,1,0,13.83Z",
    transform: "translate(0)",
    fill: "#bdc3c7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoltoLogoGrey);
export default __webpack_public_path__ + "static/media/consolto-logo-grey.22cb5587c5c0bf96ca885dd60caef323.svg";
export { ForwardRef as ReactComponent };